export default "__VITE_ASSET__CEynrgPY__"